import VueI18n from '@/i18n/locale'
import { i18n } from '@/common/utils/i18n'

export const TabNames = {
  priority: {
    label: VueI18n.t('FoodB_0820__bVDh' /** 高优门店 */),
    key: 'priorityStore',
    trackIndex: 1,
  },
  area: {
    label: VueI18n.t('FoodB_030_zOTR_tsWu' /** 商圈 */),
    key: 'areaStore',
    trackIndex: 2,
  },
  my: {
    label: VueI18n.t('Gattaran_0__VQyB' /** 我负责的 */),
    key: 'myStore',
    trackIndex: 3,
  },
  all: {
    label: i18n.gettext('全部'),
    key: 'allStore',
    trackIndex: 4,
  },
}
export const TabNameList = ['priorityStore', 'areaStore', 'myStore', 'allStore']
